import { FunctionComponent, PropsWithChildren, memo } from 'react';
import { IconLabel } from '../../IconLabel';
import { SortableItem } from '../../SortableList';

import classes from './FeedCardDrag.module.scss';

interface FeedCardDragProps {
  storyCardId: number;
}

export const FeedCardDrag: FunctionComponent<PropsWithChildren<FeedCardDragProps>> = memo(
  ({ storyCardId, children }) => {
    return (
      <SortableItem id={storyCardId} className={classes['card']}>
        <IconLabel
          iconId={'drag'}
          iconSize={14}
          className={classes['card__drag-icon']}
          singleColor
        />
        {children}
      </SortableItem>
    );
  }
);
